import * as React from 'react';
import { Link as ScrollLink } from 'react-scroll/modules';
import { PaccApplyResultVO } from '@domain/vo/phs/pacc/results/PaccApplyResultVO';
import { moduleTypeNameMap, moduleTypeStringMap } from '@domain/constant/moduleType';
import classNames from 'classnames/bind';
import styles from './applyStepProcess.module.scss';

const cx = classNames.bind(styles);

const GNB_HEIGHT = -64;

interface ApplyStepProcessProps {
  applyResult: PaccApplyResultVO;
}

const ApplyStepProcess = ({ applyResult }: ApplyStepProcessProps) => {
  if (!applyResult) return null;

  const listEl = applyResult.moduleResults?.map((moduleResult) => {
    const { module, unreliableYn } = moduleResult;
    const moduleTypeString = moduleTypeStringMap[module];
    const processName = moduleTypeNameMap[module];
    const status = unreliableYn ? 'warning' : 'good';
    const statusText = unreliableYn ? '보완점을 확인해 보세요!' : '안정적으로 응시했어요!';

    return (
      <ScrollLink key={module} to={module} offset={GNB_HEIGHT} className={cx('process')} smooth role="button">
        <div className={cx('processWrap', moduleTypeString)}>
          <div className={cx('processInfo')}>
            <em className={cx('name')}>{processName}</em>
            <span className={cx('status', status)}>{statusText}</span>
          </div>
        </div>
      </ScrollLink>
    );
  });

  return <div className={cx('processArea')}>{listEl}</div>;
};

export default ApplyStepProcess;
